import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import GroupsIcon from '@mui/icons-material/Groups';

const COMPANY_SIZE_OPTIONS = [
    { value: 'Employees_1_9', label: '1–9' },
    { value: 'Employees_10_49', label: '10–49' },
    { value: 'Employees_50_99', label: '50–99' },
    { value: 'Employees_100_249', label: '100–249' },
    { value: 'Employees_250_499', label: '250–499' },
    { value: 'Employees_500_999', label: '500–999' },
    { value: 'Employees_1000_4999', label: '1000–4999' },
    { value: 'Employees_5000_9999', label: '5000–9999' },
    { value: 'Employees_10000_24999', label: '10000–24999' },
    { value: 'Employees_25000_49999', label: '25000–49999' },
    { value: 'Employees_50000_Plus', label: '50000+' },
];

type Option = { value: string | number; label: React.ReactNode };

type Props = {
  value: string | number | null | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options?: Option[];
  label?: React.ReactNode;
};

export const CompanyProfileCompanySizeMenu: React.FC<Props> = ({ value, onChange, options = COMPANY_SIZE_OPTIONS, label = 'Company size' }) => {
  return (
    <TextField
      label={label}
      select
      fullWidth
      value={value ?? ''}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <GroupsIcon fontSize="small" sx={{ color: 'success.main' }} />
          </InputAdornment>
        ),
      }}
    >
      {options.map(opt => (
        <MenuItem key={String(opt.value)} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CompanyProfileCompanySizeMenu;
